/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, weeks: NonNullable<unknown> }} Workout_After_Week_OfInputs */

const en_us2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week} of ${i?.weeks}`)
};

const pt_br2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.weeks}`)
};

const es_419_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.weeks}`)
};

const pt_pt2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week} de ${i?.weeks}`)
};

const fr_fr2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week} sur ${i?.weeks}`)
};

const de_de2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week} von ${i?.weeks}`)
};

const it_it2_workout_after_week_of = /** @type {(inputs: Workout_After_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week} di ${i?.weeks}`)
};

/**
* | output |
* | --- |
* | "Week {week} of {weeks}" |
*
* @param {Workout_After_Week_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_week_of = /** @type {((inputs: Workout_After_Week_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Week_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_week_of(inputs)
	if (locale === "es-419") return es_419_workout_after_week_of(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_week_of(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_week_of(inputs)
	if (locale === "de-DE") return de_de2_workout_after_week_of(inputs)
	if (locale === "it-IT") return it_it2_workout_after_week_of(inputs)
	return en_us2_workout_after_week_of(inputs)
});
export { workout_after_week_of as "workout-after.week_of" }